import { render } from "./mainmenu.vue?vue&type=template&id=575e300c"
import script from "./mainmenu.vue?vue&type=script&lang=js"
export * from "./mainmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__